import { connectorApiClient } from '@/shared/api/core/axios-instance';

import type { UpdateConnectorsStatusRequest } from '@/entities/connector/types';

export const updateConnectorsStatusApi = async (request: UpdateConnectorsStatusRequest) => {
  await connectorApiClient.patch(`/connectors/status`, request);
};
